//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	var app = angular.module('pphhApp');

	app.directive("ttecScrollable", function() {
		var padding = 8;
		var SCROLL_STEP = 20;
		var SCROLL_SPEED = 30;

		var $ = angular.element;

		var $parent = null;
		var $scrollableTableDiv = null;
		var $table = null;
		var $fabDiv = null;
		let $totalOffset= 0;

		function ScrollableLink(scope, elem, attr, ctrl) {
			$parent = elem;
			$scrollableTableDiv = buildScrollableTableDiv();
			$table = elem.find("table");
			$fabDiv = findFabDiv();


			var $scrollableHeaderDiv = buildScrollableHeaderDiv();

			var $t_fixed = null;

			function findFabDiv() {
				var $candidate = null;
				angular.forEach($parent.find("div"), function(div) {
					var $div = $(div);
					if ($div.hasClass("scrollableFabDiv")) {
						$candidate = $div;
					}
				});

				return $candidate;
			}

			function buildScrollableTableDiv() {
				return $(elem.find("div")[0]);
			}

			function buildScrollableHeaderDiv() {
				var $scrollableHeaderDiv = null;

				var children = elem.find("div");
				for (var i = 0; i < children.length; i++) {
					$scrollableHeaderDiv = $(children[i]);
					if ($scrollableHeaderDiv.hasClass("scrollableHeader")) {
						break;
					}
				}

				return $scrollableHeaderDiv;
			}

			function initFloatingHeader() {
				$t_fixed = $table.clone();
				$t_fixed.removeAttr("st-pipe");
				$t_fixed.removeAttr("st-table");
				$t_fixed.find("tbody").remove();
				$t_fixed.find("tfoot").remove();
				$t_fixed.find("th").removeAttr("st-sort");

				var thead = $t_fixed.find("thead");
				var trs = $(thead).find("tr");
				for (var i = 0; i < trs.length; i++) {
					if ($(trs[i]).hasClass("ttecScrollableFilter")) {
						$(trs[i]).remove();
					}
				}

				$t_fixed.attr("aria-hidden", "true");

				$scrollableHeaderDiv.prepend($t_fixed);

				$t_fixed.css("display", "none");
			}

			function resizeFixed() {
				if ($t_fixed == null) {
					return;
				}

				$scrollableHeaderDiv.css("width", $scrollableTableDiv[0].offsetWidth + "px");

				$t_fixed.css("width", $table[0].offsetWidth + "px");

				var headerRows = $table.find("thead").find("tr");

				for (var trIndex = 0; trIndex < headerRows.length; trIndex++) {
					var $headerRow = $(headerRows[trIndex]);

					if ($headerRow.hasClass("ttecScrollableFilter")) {
						continue;
					}

					var ths = $headerRow.children();
					var fixedThs = $($t_fixed.find("thead").find("tr")[trIndex]).children();
					for (var i = 0; i < ths.length; i++) {
						// outerWidth
						var width = ths[i].offsetWidth - (padding * 2);
						$(fixedThs[i]).css("min-width", width + "px");
						$(fixedThs[i]).css("max-width", width + "px");
						$(fixedThs[i]).find("div").css("min-width", width + "px");
						$(fixedThs[i]).find("div").css("max-width", width + "px");
						$(fixedThs[i]).find("div").css("display", "inline-block");

						clickDelegate(fixedThs[i], ths[i]);
					}
				}
			}

			function clickDelegate(fixedTh, originalTh) {
				if (!$(originalTh).attr("st-sort")) {
					return;
				}
				fixedTh.onclick = function() {
					originalTh.click();

					if ($(originalTh).hasClass("st-sort-descent")) {
						$(fixedTh).removeClass("st-sort-ascent");
						$(fixedTh).addClass("st-sort-descent");
					} else if ($(originalTh).hasClass("st-sort-ascent")) {
						$(fixedTh).addClass("st-sort-ascent");
						$(fixedTh).removeClass("st-sort-descent");
					} else {
						$(fixedTh).removeClass("st-sort-ascent");
						$(fixedTh).removeClass("st-sort-descent");
					}
				};
			}

			function scrollFixed() {
				var $thead = $table.find("thead");
				var theadRect = $thead[0].getBoundingClientRect();
				var y = (theadRect.y || theadRect.top);

				if (y >= 0) {
					if ($t_fixed != null) {
						$t_fixed.remove();
						$t_fixed = null;
					}
				} else {
					if ($t_fixed == null) {
						initFloatingHeader();
					}

					var hidden = "none" === $t_fixed.css("display");
					if (hidden) {
						resizeFixed();
						$t_fixed.css("display", "table");
					}
					$scrollableHeaderDiv.css("top", "0px");
					$scrollableHeaderDiv.css("transform", "translate(0px, " + (y * -1) + "px)");
					divScroll();
				}
			}

			function scrollFab() {
				if (!hasHorizontalScroll()) {
					return;
				}

				let parentRect = $parent[0].getBoundingClientRect();
				let tableRect = $table[0].getBoundingClientRect();
				// quitamos 50 porque es la mitad de la imagen par que se ve enera al terminar el scroll.
				let offset = window.innerHeight - tableRect.top -50;
				
				$fabDiv.css("top", "0px");				
				$fabDiv.css("transform", "translate(0px, " + offset + "px)");				
			}

			function divScroll() {
				if ($t_fixed == null) {
					return;
				}

				var hidden = $t_fixed && "none" === $t_fixed.css("display");
				if (!hidden) {
					var offset = $scrollableTableDiv[0].scrollLeft;
					$scrollableHeaderDiv[0].scrollLeft = offset;
				}
			}

			function setupEventListeners() {
				var onresizeCallback = window.onresize;
				window.onresize = function() {
					if (onresizeCallback) {
						onresizeCallback.call(this);
					}
					resizeFixed.call(this);
				};

				var onscrollCallback = window.onscroll;
				window.onscroll = function() {
					if (onscrollCallback) {
						onscrollCallback.call(this);
					}
					scrollFixed.call(this);

					scrollFab.call(this);
				};

				$scrollableTableDiv[0].onscroll = divScroll;
			}

			setupEventListeners();
		}

		function hasHorizontalScroll() {
			return $scrollableTableDiv[0].scrollWidth > $scrollableTableDiv[0].offsetWidth;
		}

		function ScrollableController($scope, $interval) {
			var fabInitialized = 0;

			$scope.sourceLength = 0;

			$scope.fabInit = function() {
				fabInitialized++;
				configureFabs();
			}

			$scope.$watch("sourceLength", function() {
				configureFabs();
			});

			$scope.showFab = function() {
				return $scope.sourceLength > 0 && hasHorizontalScroll();
			};

			var scrollPromise = null;

			$scope.scrollLeft = function() {
				$scope.stopScroll();

				performHorizontalScroll(-1 * SCROLL_STEP);
				scrollPromise = $interval(function() {
					performHorizontalScroll(-1 * SCROLL_STEP);
				}, SCROLL_SPEED);
			};

			$scope.scrollRight = function() {
				$scope.stopScroll();

				performHorizontalScroll(SCROLL_STEP);
				scrollPromise = $interval(function() {
					performHorizontalScroll(SCROLL_STEP);
				}, SCROLL_SPEED);
			};

			$scope.stopScroll = function() {
				if (scrollPromise) {
					$interval.cancel(scrollPromise);
				}
				scrollPromise = null;
			};

			function configureFabs() {
				if (fabInitialized < 2 || $scope.sourceLength === 0 || !hasHorizontalScroll()) {
					return;
				}

				var tableRect = $table[0].getBoundingClientRect();
				// quitamos 50 porque es la mitad de la imagen par que se ve enera al terminar el scroll 
				//y permitir una inicializacion correcta dela posicion
				var offset = window.innerHeight - tableRect.top -50;

				$fabDiv.css("top", "0px");
				$fabDiv.css("transform", "translate(0px, " + (offset) + "px)");
			}

			function performHorizontalScroll(step) {
				var left = $scrollableTableDiv[0].scrollLeft;
				if ($scrollableTableDiv[0].scrollTo) {
					$scrollableTableDiv[0].scrollTo(left + step, 0);
				} else {
					$scrollableTableDiv[0].scrollLeft = left + step;
				}
			}
		}

		return {
			restrict: "E",
			scope: {
				sourceLength: "=?"
			},
			transclude: {
				table: 'table',
			},
			template: ''

				+ '<div class="scrollableTable">'
				+ '  <div class="scrollableTableInner" ng-transclude="table"></div>'
				+ '</div>'
				+ '<div class="scrollableHeader"></div>'

				+ '<div class="scrollableFabDiv" style="position: absolute; width: 100%; top: 20%;" aria-hidden="true">'
				+ '  <md-fab-speed-dial class="md-fab-bottom-left" ng-if="showFab()" ng-init="fabInit()">'
				+ '    <md-fab-trigger>'
				+ '      <md-button aria-label="menu" class="md-fab" ng-mousedown="scrollLeft()" ng-mouseup="stopScroll()">'
				+ '        <md-icon class="material-icons md-24" aria-label="Desplazar a la izquierda">keyboard_arrow_left</md-icon>'
				+ '      </md-button>'
				+ '    </md-fab-trigger>'
				+ '  </md-fab-speed-dial>'
				+ '  <md-fab-speed-dial class="md-fab-bottom-right" ng-if="showFab()" ng-init="fabInit()">'
				+ '    <md-fab-trigger>'
				+ '      <md-button aria-label="menu" class="md-fab" ng-mousedown="scrollRight()" ng-mouseup="stopScroll()">'
				+ '        <md-icon class="material-icons md-24" aria-label="Desplazar a la derecha">keyboard_arrow_right</md-icon>'
				+ '      </md-button>'
				+ '    </md-fab-trigger>'
				+ '  </md-fab-speed-dial>'
				+ '</div>'
			,
			link: ScrollableLink,
			controller: ["$scope", "$interval", ScrollableController]
		};
	});

})();